import HyundaiBG from 'src/content/images/OEMBackgrounds/HyundaiBG.png';
import NissanBG from 'src/content/images/OEMBackgrounds/NissanBG.png';
import ChryslerBG from 'src/content/images/OEMBackgrounds/ChryslerBG.png';
import FordBG from 'src/content/images/OEMBackgrounds/FordBG.png';
import HondaBG from 'src/content/images/OEMBackgrounds/HondaBG.png';
import JeepBG from 'src/content/images/OEMBackgrounds/JeepBG.png';
import DodgeBG from 'src/content/images/OEMBackgrounds/DodgeBG.png';
import InfinitiBG from 'src/content/images/OEMBackgrounds/InfinitiBG.jpg';
import PorscheBG from 'src/content/images/OEMBackgrounds/PorscheBG.png';
import MINIBG from 'src/content/images/OEMBackgrounds/MINIBG.png';
import ToyotaBG from 'src/content/images/OEMBackgrounds/ToyotaBG.png';
import LandRoverBG from 'src/content/images/OEMBackgrounds/LandRoverBG.png';
import LexusBG from 'src/content/images/OEMBackgrounds/LexusBG.png';
import VolkswagenBG from 'src/content/images/OEMBackgrounds/VolkswagenBG.png';
import LincolnBG from 'src/content/images/OEMBackgrounds/LincolnBG.png';
import KiaBG from 'src/content/images/OEMBackgrounds/KiaBG2.jpg';
import RamBG from 'src/content/images/OEMBackgrounds/RamBG.png';
import AcuraBG from 'src/content/images/OEMBackgrounds/AcuraBG.png';
import BMWBG from 'src/content/images/OEMBackgrounds/BMWBG.jpg';
import CadillacBG from 'src/content/images/OEMBackgrounds/CadillacBG.jpg';
import BuickBG from 'src/content/images/OEMBackgrounds/NewBuickBG.jpg';
import GMBG from 'src/content/images/OEMBackgrounds/GMBG.png';
import GMCBG from 'src/content/images/OEMBackgrounds/GMCBG.png';
import ChevroletBG from 'src/content/images/OEMBackgrounds/ChevroletBG.png';
import MercedesBG from 'src/content/images/OEMBackgrounds/MercedesBG.png';
import CDJRBG from 'src/content/images/OEMBackgrounds/CDJRBG.png';
import MazdaBG from 'src/content/images/OEMBackgrounds/MazdaBG.png';
import AudiBG from 'src/content/images/OEMBackgrounds/AudiBG.jpg';
import JaguarBG from 'src/content/images/OEMBackgrounds/JaguarBG.png';
import SubaruBG from 'src/content/images/OEMBackgrounds/SubaruBG.png';
import DefaultBG from 'src/content/images/Landing.png';
import AcuraFI from 'src/content/favicons/AcuraFavicon.ico';
import AcuraCanadaFI from 'src/content/favicons/AcuraCanadaFavicon.png';
import AudiFI from 'src/content/favicons/AudiFavicon.ico';
import BMWFI from 'src/content/favicons/BMWFavicon.ico';
import BuickFI from 'src/content/favicons/BuickFavicon.ico';
import CadillacFI from 'src/content/favicons/CadillacFavicon.svg';
import CDJRFI from 'src/content/images/Makes/CDJR.png';
import ChevyFI from 'src/content/favicons/ChevyFavicon.ico';
import ChryslerFI from 'src/content/favicons/Chrysler.ico';
import DodgeFI from 'src/content/favicons/DodgeFavicon.ico';
import EraFI from 'src/content/favicons/era.ico';
import FordFI from 'src/content/favicons/Favicon-Ford-SVG.svg';
import GMFI from 'src/content/favicons/GM.ico';
import GMCFI from 'src/content/favicons/GMC.ico';
import HondaFI from 'src/content/favicons/HondaFavicon.ico';
import HondaCAFI from 'src/content/favicons/HondaCAFavicon.svg';
import HyundaiFI from 'src/content/favicons/hyundai.ico';
import InfinitiFI from 'src/content/favicons/Infiniti-favicon.ico';
import JaguarFI from 'src/content/favicons/JaguarFavicon.svg';
import JeepFI from 'src/content/favicons/JeepFavicon.ico';
import KiaFI from 'src/content/favicons/KiaFavicon.ico';
import LandRoverFI from 'src/content/favicons/LandRoverFavicon.svg';
import LexusFI from 'src/content/favicons/LexusFavicon.ico';
import LincolnFI from 'src/content/favicons/LincolnFavicon.ico';
import MazdaFI from 'src/content/favicons/MazdaFavicon.ico';
import MercedesFI from 'src/content/favicons/MercedesFavicon.ico';
import MINIFI from 'src/content/favicons/MINIFavicon.ico';
import NissanFI from 'src/content/favicons/NissanFav.ico';
import PorscheFI from 'src/content/favicons/PorscheFavicon.ico';
import RamFI from 'src/content/favicons/RamFavicon.ico';
import SubaruFI from 'src/content/favicons/Subaru-favicon.ico';
import ToyotaFI from 'src/content/favicons/ToyotaFavicon.ico';
import VolkswagenFI from 'src/content/favicons/Volkswagen.ico';

export const checkSpecTheme = (theme: string) => {
    switch (theme) {
        case 'AB':
            return 'acura-CA';

        case 'AC':
            return 'acura';

        case 'AU':
            return 'audi';

        case 'BM':
            return 'bmw';

        case 'BU':
            return 'buick';

        case 'CD':
            return 'cadillac';

        case 'CV':
            return 'chevrolet';

        case 'CH':
            return 'chrysler';
        case 'CJ':
            return 'cjdr';

        case 'DO':
            return 'dodge';

        case 'FO':
            return 'ford';

        case 'HA':
            return 'honda-CA';

        case 'HO':
            return 'honda';

        case 'HY':
            return 'hyundai';

        case 'IN':
            return 'infiniti';

        case 'JA':
            return 'jaguar';

        case 'JE':
            return 'jeep';

        case 'KI':
            return 'kia';

        case 'GM':
            return 'gm';

        case 'GC':
            return 'gmc';

        case 'LR':
            return 'landRover';

        case 'LE':
            return 'lexus';

        case 'LM':
            return 'lexusMonogram';

        case 'LI':
            return 'lincoln';

        case 'MA':
            return 'mazda';

        case 'MB':
            return 'mercedesBenz';

        case 'M':
            return 'mini';

        case 'NI':
            return 'nissan';

        case 'PO':
            return 'porsche';

        case 'RM':
            return 'ram';

        case 'SU':
            return 'subaru';

        case 'TO':
            return 'toyota';

        case 'TS':
            return 'toyotaSPM';

        case 'VW':
            return 'volkswagen';

        case 'D':
        default:
            return 'normal';
    }
};

export const getFavIconPath = (theme: string) => {
    switch (theme) {
        // Favicons and other assets should be kept outside of the public folder for easier access and maintenance
        // They are now located in src/content/favicons, except for GMC and CDJR, which use pngs from src/images/Makes
        // Makes without a make image should default to the ERA icon

        case 'AB':
            return AcuraCanadaFI;

        case 'AC':
            return AcuraFI;

        case 'AU':
            return AudiFI;

        case 'BM':
            return BMWFI;

        case 'BU':
            return BuickFI;

        case 'CD':
            return CadillacFI;

        case 'CJ':
            return CDJRFI;

        case 'CV':
            return ChevyFI;

        case 'CH':
            return ChryslerFI;

        case 'DO':
            return DodgeFI;

        case 'FO':
            return FordFI;

        case 'GC':
            return GMCFI;

        case 'GM':
            return GMFI;

        case 'HA':
            return HondaCAFI;

        case 'HO':
            return HondaFI;

        case 'HY':
            return HyundaiFI;

        case 'IN':
            return InfinitiFI;

        case 'JA':
            return JaguarFI;

        case 'JE':
            return JeepFI;

        case 'KI':
            return KiaFI;

        case 'LR':
            return LandRoverFI;

        case 'LE':
            return LexusFI;

        case 'LI':
            return LincolnFI;

        case 'MA':
            return MazdaFI;

        case 'MB':
            return MercedesFI;

        case 'M':
            return MINIFI;

        case 'NI':
            return NissanFI;

        case 'PO':
            return PorscheFI;

        case 'RM':
            return RamFI;

        case 'SU':
            return SubaruFI;

        case 'TO':
            return ToyotaFI;

        case 'TO':
            return ToyotaFI;

        case 'TS':
            return ToyotaFI;

        case 'VW':
            return VolkswagenFI;

        case 'D':

        default:
            return EraFI;
    }
};

export const getBackgroundPath = (theme: string) => {
    switch (theme) {
        case 'AC':
            return 'transparent';

        case 'AU':
            return 'url(' + AudiBG + ')';

        case 'BM':
            return 'transparent';

        case 'BU':
            return 'transparent';

        case 'CD':
            return 'transparent';
        case 'CV':
            return 'transparent';

        case 'CH':
            return 'url('+ ChryslerBG + ')';

        case 'CJ':
            return 'url(' + CDJRBG + ')';

        case 'DO':
            return 'url(' + DodgeBG + ')';

        case 'FO':
            return 'url(' + FordBG + ')';

        case 'HA':
            return 'url(' + HondaBG + ')';

        case 'HO':
            return 'transparent';

        case 'HY':
            return 'url('+ HyundaiBG + ')';

        case 'IN':
            return 'url('+ InfinitiBG + ')';

        case 'JA':
            return 'url(' + JaguarBG + ')';

        case 'JE':
            return 'url('+ JeepBG + ')';

        case 'KI':
            return 'url(' + KiaBG + ')';

        case 'GM':
            return 'url(' + GMBG + ')';

        case 'GC':
            return 'url(' + GMCBG + ')';

        case 'LR':
            return 'url('+ LandRoverBG +')';

        case 'LE':
            return 'url('+ LexusBG +')';

        case 'LI':
            return 'url(' + LincolnBG + ')';

        case 'MA':
            return 'transparent';

        case 'MB':
            return 'url(' + MercedesBG + ')';

        case 'M':
            return 'url(' + MINIBG + ')';

        case 'NI':
            return 'transparent';

        case 'PO':
            // return 'url(' + PorscheBG + ')';
            return 'transparent';

        case 'RM':
            return 'url(' + RamBG + ')';

        case 'SU':
            return 'transparent';

        case 'TO':
            return 'url(' + ToyotaBG + ')';

        case 'TS':
            return 'url(' + ToyotaBG + ')';

        case 'VW':
            return 'url(' + VolkswagenBG + ')';

        case 'D':
            return 'url(' + DefaultBG + ')';
        default:
            return '';
    }
};